import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Dr. Leder', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <>
      <nav className={`fixed w-full z-50 bg-white border-b border-teal-100 transition-all duration-300 ${isScrolled ? 'shadow-sm' : ''}`}>
        <div className="px-6 lg:px-12">
          <div className="flex justify-between items-center h-20">
            {/* Logo */}
            <Link to="/" className="flex items-center flex-shrink-0">
              <img
                src="https://storage.readdy-site.link/project_files/3236bba1-19d1-4b50-b72d-8ce744c77a64/988a6fa3-2231-4724-b521-293e258ee7f0_betteralternativelogo.png?v=d535279da15a85e83647673b64272d19"
                alt="A Better Alternative Medical Center – Dr. Robin Ellen Leder MD"
                className="h-14 w-auto block"
                style={{ border: 'none', outline: 'none', boxShadow: 'none' }}
              />
            </Link>

            {/* Desktop Nav */}
            <div className="hidden lg:flex items-center gap-8">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-sm font-medium tracking-wide transition-colors whitespace-nowrap cursor-pointer ${
                    location.pathname === link.path ? 'text-teal-600' : 'text-teal-900 hover:text-teal-600'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <a
                href="tel:2015251155"
                className="flex items-center gap-2 text-sm font-semibold text-teal-900 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-fill text-teal-500 text-base"></i>
                </div>
                (201) 525-1155
              </a>
              <Link
                to="/contact"
                className="bg-teal-700 text-white px-6 py-2.5 rounded-md text-sm font-semibold hover:bg-teal-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                Book Appointment
              </Link>
            </div>

            {/* Mobile Menu Toggle */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden p-2 cursor-pointer text-teal-900"
              aria-label="Toggle menu"
            >
              <div className="w-6 h-5 flex flex-col justify-between">
                <span className={`block h-0.5 w-full bg-current transition-all duration-300 ${isMobileMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
                <span className={`block h-0.5 w-full bg-current transition-all duration-300 ${isMobileMenuOpen ? 'opacity-0' : ''}`}></span>
                <span className={`block h-0.5 w-full bg-current transition-all duration-300 ${isMobileMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
              </div>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-white border-t border-teal-100">
            <div className="px-6 py-5 space-y-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`block text-sm font-medium py-1 cursor-pointer ${
                    location.pathname === link.path ? 'text-teal-600' : 'text-teal-900'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <div className="pt-2 space-y-3">
                <a
                  href="tel:2015251155"
                  className="flex items-center gap-2 bg-teal-50 text-teal-800 px-4 py-3 rounded-md text-sm font-semibold cursor-pointer"
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-phone-fill text-teal-600 text-base"></i>
                  </div>
                  Call Now: (201) 525-1155
                </a>
                <Link
                  to="/contact"
                  className="block w-full bg-teal-700 text-white px-4 py-3 rounded-md text-sm font-semibold text-center cursor-pointer whitespace-nowrap"
                >
                  Book Appointment
                </Link>
              </div>
            </div>
          </div>
        )}
      </nav>

      {/* Mobile Sticky Click-to-Call Bar */}
      <div className="fixed bottom-0 left-0 right-0 z-50 lg:hidden bg-teal-700 text-white">
        <div className="grid grid-cols-2">
          <a
            href="tel:2015251155"
            className="flex items-center justify-center gap-2 py-4 text-sm font-semibold border-r border-teal-600 cursor-pointer"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-fill text-white text-lg"></i>
            </div>
            Call Now
          </a>
          <Link
            to="/contact"
            className="flex items-center justify-center gap-2 py-4 text-sm font-semibold cursor-pointer"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-calendar-check-line text-white text-lg"></i>
            </div>
            Book Appointment
          </Link>
        </div>
      </div>
    </>
  );
}
